import { JsonObject, JsonProperty } from 'json2typescript';


@JsonObject
export class LearnCertDisableConfig {
  @JsonProperty('id', Number, true)
  id: number = undefined;

  @JsonProperty('createTime', Number, true)
  createTime: number = undefined;

  @JsonProperty('lastModified', Number, true)
  lastModified: number = undefined;

  @JsonProperty('tenantId', Number)
  tenantId: number = undefined;

  @JsonProperty('name', String)
  name: string = undefined;

  @JsonProperty('deptIds', [Number])
  deptIds: number[] = [];

  @JsonProperty('groupIds', [Number])
  groupIds: number[] = [];

  @JsonProperty('learnCertClassIds', [Number])
  learnCertClassIds: number[] = [];

  @JsonProperty('learnCertTypeIds', [Number])
  learnCertTypeIds: number[] = [];
}
